import { render } from "./categoryOverviewTeaser.vue?vue&type=template&id=6b1e0593"
import script from "./categoryOverviewTeaser.vue?vue&type=script&lang=js"
export * from "./categoryOverviewTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__